import React, { useContext } from 'react';
import { CrDropdown } from './cr/CrDropdown';
import { SignOffType } from '../refData/SignOffType';
import { OrbUserContext } from './OrbUserContext';

export interface IReportTypeSelectorProps {
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    types: SignOffType[];
    selectedType: SignOffType;
    onChange: (type: SignOffType) => void;
}

export const ReportTypeSelector = ({ placeholder, types, selectedType, onChange, ...others }: IReportTypeSelectorProps): React.ReactElement => {
    const { orbConfig } = useContext(OrbUserContext);
    return (
        <CrDropdown
            {...others}
            options={types.map(t => ({
                key: t, text: t === SignOffType.Directorate ? `${orbConfig.OrgL2Label}`
                    : t === SignOffType.PartnerOrganisation ? 'Partner organisation'
                        : t === SignOffType.Project ? 'Project'
                            : t === SignOffType.Risk ? 'Risk'
                                : t === SignOffType.Portfolio ? 'Portfolio'
                                    : t === SignOffType.Programme ? 'Programme'
                                        : t === SignOffType.FinancialRisk ? 'Financial risk' : null
            }))}
            selectedKey={selectedType}
            onChange={(_, o) => onChange(Number(o.key))}
            placeholder={placeholder || 'Select report type'}
        />
    );
};
